import { Box } from "@mui/material";
import React from "react";
import WithLove from "../../common/components/WithLove";
// import dayOne from "../../images/day1.png";
// import creation from "../../images/creation.png";
import Topic from "../../common/components/Topic";
import Picture from "../../common/components/Picture";
import Title from "../../common/components/Title";
import Content from "../../common/components/Content";
import Subtitle from "../../common/components/Subtitle";
import Text from "../../common/components/Text";
import SubSection from "../../common/components/SubSection";
import Section from "../../common/components/Section";
// import Number from "../../common/components/Number";
import Bullet from "../../common/components/Bullet";

// Images

import cover from "../../images/4.0/day3/0. Introduction.jpg";
import strongMeat from "../../images/4.0/day3/1. Strong Meat.jpg";
import transition from "../../images/4.0/day3/2. Transitioning.jpg";
import discerning from "../../images/4.0/day3/3. Discerning.jpg";
import choosing from "../../images/4.0/day3/4. Choosing.jpg";
import dangers from "../../images/4.0/day3/5. Dangers.jpg";
import culture from "../../images/4.0/day3/7. Culture.jpg";
import overcoming from "../../images/4.0/day3/8. Overcoming.jpg";
import tig from "../../images/4.0/day3/9. The Incorruptiple Generation.jpg";

export default function FourDayThree() {
  return (
    <>
      <Box>
        <Topic>
          The Strong Meat, God's Provision to Immune the Soul from Corruption{" "}
        </Topic>
        <Text>Hebrews 5:14, 1 Peter 1:23, Hebrews 4:12, 1 John 3:9.</Text>
        <br />
      </Box>
      <Picture src={cover} />
      <Section>
        <Section>
          <Title>Introduction </Title>
          <Content>
            {/* You are welcome to <b>Gadites Bible Seminar 4.0</b>.
            <br />
            <br /> */}
            In our previous study, we have been able to see that the problem of
            man is the corruptible seed and corruption. We've also seen that the
            provision of the milk isn't able to arrest corruption but prepares
            the believer for the meat of God's Word which is the allocation of
            Christ. The Doctrine of Christ is God's provision to arrest
            corruption.
            <br />
            <br />
            However the doctrine of Christ isn't potent enough to make a
            believer believer incorruptible. Hence, the need for a higher
            allocation of the word, which is the Strong meat of God's Word. In
            this study, we would be exploring this allocation of God's word. We
            trust the Lord for grace, skill, utterance, and understanding in
            Jesus name. Amen.
          </Content>
        </Section>
        <br />
        <Section>
          <Title>THE STRONG MEAT</Title>
          <br />
          <Picture src={strongMeat} />
          <br />
          <br />
          <Content>
            As we have earlier established, the meat of the word is the word of
            Christ, which a believer who has been weaned from the milk is
            exposed to <b>(1 Cor. 3:3, 10:3-4, Isaiah 28:9).</b> This allocation
            of God's word matures the child to becoming a man or one that is of
            full age <b>(Heb. 5:14, 1 Cor. 13:11).</b> The meal, according to 1
            Cor. 10:3-4, is a spiritual; thus, it is a meal allocation that is
            able to make the believer spiritual.
            <br />
            <br />
            We must emphasize that being spiritual is not a function of long
            hours of prayer, or manifesting the gifts of the Spirit{" "}
            <b>(1 Cor. 1:7, 12:7-12, 14:26, 3:1).</b> Rather, it is attaining a
            stature or quality of being, which is a nature of life and
            peace/godliness <b>(Rom 8:6, 2 Pet 1:4, 1 Tim 6:6).</b> According to
            Hebrews 5:14, we find that being spiritual or of full age is not the
            end of the believer's growth. Rather, it is a growth level required
            to partake of a higher allocation of God's word, which is called the
            strong meat or the word of righteousness.
            <br />
            <br />
            Another perspective to maturity, according to 1 Cor. 2:6, Phil 3:15,
            and Eph 4:13, is becoming a perfect man. It is important we
            understand that this perfectness is a state of completeness in the
            doctrine of Christ or meat <b>(Col 1:28),</b> as there is still more
            maturity to attain from the scriptures we read earlier. This level
            of perfectness is attaining the greatest life in the doctrine of
            Christ, which is charity <b>(Col. 3:14-15, Eph 4:3).</b>
            <br />
            <br />A perfect man in Christ is one that should go on to attain a
            higher level of maturity, which is being perfect as the Father or
            attaining perfection <b>(Matt. 5:48, Heb. 6:1).</b> This perfection
            cannot be attained without a higher allocation of God's word
            referred to as the strong meat or the hidden wisdom of God{" "}
            <b>(1 Cor. 2:6-7).</b> Thus, we can conclude that the strong meat of
            God's word communicates the hidden wisdom of God or the word of God,
            which is the incorruptible seed{" "}
            <b>(1 Pet 1:23, James 1:21, Heb. 4:12).</b> This word enables the
            spiritual man to be born of God, making him a Son of God{" "}
            <b>(Matt 16:16, Eph 4:13, Heb. 7:3).</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>Transitioning from the Meat to Strong Meat </Title>

          <br />
          <Picture src={transition} />
          <br />
          <br />
          <Content>
            It is good to reiterate that the meat of the word is the word of
            Christ while the strong meat of the word is the word of God,{" "}
            <b>(Col. 3:16, Heb. 4:12).</b> According to scriptures, we find that
            there is a season of transitioning between these meals: meat and
            strong meat. This season is a period of trial, which can be likened
            to an experience of fire or burning to further purify the spiritual
            men for the word of God <b>(Matt 5:8, 1 Pet 1:7, 4:12-13).</b>
            <br />
            <br />
            It is important to note that this season of high purification is
            initiated by our Lord Jesus Christ to take these men into the world
            of the Father, <b>(Mal 3:1-3, Heb 2:10-11).</b> In this fiery season
            of trial, the spiritual believers are admonished to make their love
            for one another fervent or fiery <b>(1 Pet 1:22).</b>
            <br />
            <br />
            Fervent charity, according to 2 Peter 1:5-8, means to abound in
            virtue, knowledge, temperance, patience, godliness, brotherly
            kindness, and charity, making them fit to enter the everlasting
            kingdom or the world of the Father. At the end of this season, these
            believers are made new born babes in the world of the Father, ready
            to partake of the milk of the incorruptible word of God{" "}
            <b>(1 Pet 2:1).</b>
            <br />
            <br />
            As we have established earlier, the strong meat of the word is
            likened to milk and honey or butter and honey, which is needed in
            the exercise of discerning good and evil, to choose the good and
            refuse the evil <b>(Exodus 3:8, Isaiah 7:15,22).</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>DISCERNING GOOD AND EVIL </Title>
          <br />
          <Picture src={discerning} />
          <br />
          <br />
          <Content>
            The word of Christ matures a believer to full age, giving such a one
            the wisdom to be able to participate in the exercise of discerning
            good and evil <b>(Heb. 5:14).</b> We must emphasize that good here
            speaks of the nature of God, while evil describes the nature of the
            devil <b>(Mark 10:18, John 8:44).</b>
            <br />
            <br />
            Thus, discerning good is acquiring wisdom in God's life or knowing
            that which is right in God's sight. This wisdom, when obeyed, forms
            the Son of God, who is fully perfect or incorruptible,{" "}
            <b>(Phi 2:15-16, 3 John 1:11-12, 1 Pet. 2:12, Tit 2:14).</b> On the
            other hand, this exercise exposes the highest wisdom of the devil,
            which is evil.
            <br />
            <br />
            It is good to note that evil here is not diabolic or demonic, but is
            a high wisdom of life that may seem harmless to a simple mind but is
            against God's standard of righteousness{" "}
            <b>(James 1:13, 3:16; I John 3:12, 3 John 1:11).</b> Paul, in
            Ephesians 6:7, refers to this wisdom as the wiles of the devil or
            wickedness.
            <br />
            <br />
            We must also understand that this wisdom is higher than the wisdom
            of the world that forms the worldly and ungodly man; it is the
            wisdom of the prince of the power of the air - the devil,{" "}
            <b>(Eph 2:2, 1 Cor. 2:6, 8).</b> Hence, this wisdom, when obeyed,
            forms the devilish or wicked man, who is corruptible or destroyed.
            The exercise of judging or discerning good and evil is aided by the
            strong meat or the word of God and only a spiritual man can
            participate in this process, <b>(1 Cor. 2:13-15).</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>CHOOSING GOOD AND REFUSING EVIL </Title>
          <br />
          <Picture src={choosing} />
          <br />
          <br />
          <Content>
            We must understand that it is one thing to discern good and evil and
            another to choose good and refuse evil. The word of God does not
            only reveal good and evil but also empowers the believer to make a
            choice of refusing evil and cleaving to good,{" "}
            <b>(Isaiah 7:15, Rom 12:9, 16:19; 1 Thess 5:21-22).</b>
            <br />
            <br />
            The exercise of choosing is done by obedience or commitment to
            either life. Thus, this season is that of great temptation for the
            believers in this realm. However, it is good to mention that our
            Lord Jesus Christ intercedes for these men to make the choice of
            God's life and refuse the devil's offer,{" "}
            <b>(2 Peter 2:9, James 1:2, Heb 2:18, Matt 6:13).</b>
            <br />
            <br />
            Psalm 139:23-24 gives us a graphic description of this season: the
            word of God (incorruptible seed) thoroughly searches the hearts and
            thoughts of the believer to expose or reveal evil or wicked
            tendencies (the corruptible seed) within the soul, and God then
            leads them against this tendencies. Consequently, as the soul obeys
            this leading, the believer experiences deliverance until he is fully
            born of God.
            <br />
            <br />
            Thus, this believer is one who is immune to Sin because the root of
            corruption (corruptible seed) has been removed and the life of God
            has been fully installed, <b>(1 John 3:9).</b> The end of this
            season brings believers to a state of loving righteousness and
            hating wickedness <b>(Psalm 45:7, Heb. 1:9).</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>Dangers of choosing evil. </Title>

          <br />
          <Picture src={dangers} />
          <br />
          <br />
          <Content>
            It is also very important to mention that, according to scriptures,
            it is possible to choose evil and refuse good <b>(Psalm 52:3).</b>{" "}
            This activity is referred to in scriptures as committing the
            unpardonable sin or the sin unto death, <b>(1 John 5:16).</b> This
            is a disastrous experience as it is such that can make an ungodly
            man, and even a careless believer, eternally damned. This is a state
            of great death, making such men fit for the lake of fire,{" "}
            <b>(Jude 1:12, Rev 20:12, 14).</b>
            <br />
            <br />
            These believers are those that Peter refers to in 2 Pet as2:22, dogs
            who returned to their vomits and swine that returned to wallowing in
            the mire, <b>(2 Pet 2:20-22).</b> In Hebrews, Paul emphasizes that
            it is impossible for these men to be renewed again to repentance
            because they have sinned wilfully, <b>(Heb. 6:4-6, 10:26).</b>{" "}
            Sinning willfully means they decided consciously and deliberately,
            without deception, to choose Satan's life rather than God's,{" "}
            <b>(Rom 1:28).</b>
            <br />
            <br />
            These men have attained the totally of the nature of Satan and his
            Angels. They do not seek forgiveness nor are sorrowful or repentant
            of their actions, <b>(Matt 12:31-32).</b> They have raised their
            hearts in pride against the Father and his Son, sinning against the
            Holy Ghost, <b>(Heb. 6:6, 2 Pet 2:1, Jude 1:4, Heb. 10:29).</b> They
            are described in scriptures as being born of the devil or being of
            the wicked one, <b>(1 John 3:8, 10).</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>
            Notable Examples of those who were born of the corruptible seed.
          </Title>
          <Content>
            Some scriptural examples of men who were born of the corruptible
            seed there by attaining the devilish nature are,
            <SubSection>
              <Bullet>
                <Subtitle>Cain</Subtitle>
                <Content>
                  A notable example, in the Old Testament, of a man who was born
                  of the corruptible seed is Cain <b>(Genesis 4:1-17).</b>{" "}
                  Scripture records in 1 John 3:12 that he was of that wicked
                  one, i.e., he was born of the devil. Although Adam opened the
                  door for the corruptible seed to enter the human race, he did
                  not commit himself to be born of the seed{" "}
                  <b>(Rom 5:12, Gen 3:21).</b>
                  <br />
                  <br />
                  Cain, on the other hand, despite God's warning, went on to
                  interact with this seed and committed himself to it; this was
                  evident in that he was able to murder his brother, Abel{" "}
                  <b>(Gen 4:6-9, 1 John 3:12).</b> He further departed from the
                  presence of God to build a city, where his progeny began a
                  civilization of life against God <b>(Gen 4:16-24).</b>
                  <br />
                  <br />
                  Over generations, the corruptible life in Cain's progeny
                  spread on the earth, causing humanity to be corrupt before God
                  <b>(Gen 6:1, 5, 11).</b> God in mercy had to destroy humanity
                  in the flood hindering the corruptible life from taking over
                  the earth, by which God saved Noah and his family{" "}
                  <b>(Gen 6:8, 2 Pet 2:5).</b>
                </Content>
              </Bullet>
            </SubSection>
            <SubSection>
              <Bullet>
                <Subtitle>Diotrophes</Subtitle>
                <Content>
                  A notable example, in the days of the Apostles, of a man who
                  attained the corruptible nature was a man called Diotrophes.
                  <br />
                  <br />
                  In 3 John 9-11, the Apostle John described Diotrophes as a man
                  who loved to have pre-eminence, exalting himself against the
                  spiritual authority of the Apostles, <b>
                    (2 Peter 2:10).
                  </b>{" "}
                  His deeds are referred to as evil, showing that he committed
                  himself to the corruptible nature of Satan who loved to have
                  pre-eminence in the heavens, exalting himself against God{" "}
                  <b>(Isaiah 14:14).</b>
                  <br />
                  <br />
                  Another example in the days of the Apostles was Alexander the
                  Coppersmith <b>(2 Tim 4:14-15).</b>
                </Content>
              </Bullet>
            </SubSection>
            <SubSection>
              <Bullet>
                <Subtitle>The Beast</Subtitle>
                <Content>
                  This is the perfect example of a man who was fully born of the
                  corruptible seed, thereby inheriting the corruptible life of
                  Satan. According to 2 Thess. 2:3-4, this man is described as
                  the man of sin, the Son of perdition or destruction.
                  <br />
                  <br />
                  He opposes and exalts himself above God, which is the same
                  nature in Satan <b>(Isaiah 14:14).</b> He is a man, who the
                  scripture prophesies would arise in the last days and cause
                  many men to go into perdition and destruction{" "}
                  <b>(Rev. 13:1-8).</b>
                  <br />
                  <br />
                  It is good to know that this man and his false prophet would
                  be the first to be cast into the lake of fire because they
                  have attained a stature of destruction <b>(Rev. 19:20).</b>
                </Content>
              </Bullet>
            </SubSection>
            <br />
            It is good to emphasize that there is no longer repentance for these
            men and others who trail their path and thus, they'll all be cast
            into the lake of fire for all eternity with their father, the devil
            and all his angels <b>(Rev 19:20, 20:10, 20:15, and 21:8).</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>Culture of Safety in the Season of Temptation.</Title>
          <br />
          <Picture src={culture} />
          <br />
          <br />
          <Content>
            As we have earlier emphasized, the season of temptation is a time of
            peril and danger as even a spiritual believer can be born of the
            corruptible seed, becoming eternally damned,{" "}
            <b>(Heb. 2:18, 1 Pet. 1:6, 1 Pet. 1:23).</b> Peter emphasizes that
            it is better for such men to never have known the way of
            righteousness or the holy commandment because their new state is
            worse than their beginning, <b>(2 Pet. 2:20-21).</b>
            <br />
            <br />
            More so, we find that the Apostles would rather pray that the flesh
            of these men were destroyed (i.e., die physically) than they
            attaining the corruptible nature,{" "}
            <b>(1 Cor. 5:4-5, 1 Tim 1:19-20).</b> There is a heart culture that
            the scriptures admonish believers who have arrived at this junction
            to possess - a heart culture of godly fear,{" "}
            <b>(Heb. 4:1, 12:28-29).</b>
            <br />
            <br />
            This fear is not a morbid fear but rather a culture of reverence and
            carefulness, knowing it is possible to still die at this height of
            growth. We find this culture in our Lord Jesus Christ, who in the
            days of his flesh besought God, in fear, to save him from death,{" "}
            <b>(Heb. 5:7).</b>
            The evidence of the presence of this godly fear in the soul is seen
            in an eagerness to submit to spiritual authority and even one
            another,
            <b>(Eph 5:21, 1 Pet 5:5).</b> This fear teaches the believer to
            reverence and submit to the elder and one another.
            <br />
            <br />
            It is dangerous for a believer at this junction to live in isolation
            as he can become a prey for the roaring lion. Thus, safety in the
            time of temptation is simply remaining under the mighty hand of God
            (spiritual authority),
            <b>(1 Pet 5:6-8).</b>
          </Content>
        </Section>
        <br />
        <Section>
          <Title>Overcoming the Devil:</Title>
          <br />
          <Picture src={overcoming} />
          <br />
          <br />
          <SubSection>
            <Content>
              It is good to know that the process of continuously choosing good
              and refusing evil is a warfare against the devil himself,{" "}
              <b>(Rom 16:19-20, 1 Thess. 5:21-24).</b> Thus, the end of this
              process is overcoming the doer of evil (devil); the believer who
              continuously refuses the devil and commits himself to the
              incorruptible seed would finally be born of God, becoming a Son of
              God, <b>(I John 3:8-9).</b>
              <br />
              <br />
              Hence, a Son of God, is a believer in whom the things of Satan or
              the corruptible seed has been expunged and the things of God or
              the incorruptible life has been fully embodied{" "}
              <b>(John 14:30).</b> Such a believer loves righteousness and hates
              iniquity and thus, is above the reach of the wisdom of the Serpent{" "}
              <b>(Heb. 1:9, 1 John 5:18).</b>
              <br />
              <br />
              In scriptures, this state is described as bruising the serpent
              under your feet, <b>(Gen 3:15, Rom 16:20).</b> We must emphasize
              that this is vision of God for every New Testament saint. The
              intention of God is to raise a believer to a point where he is
              above the wiles of Satan, <b>(Eph 6:11, Psa. 91:13).</b>
            </Content>
          </SubSection>
        </Section>
        <br />
        <Section>
          <Title>The Incorruptible Generation</Title>

          <br />
          <Picture src={tig} />
          <br />
          <br />
          <Content>
            The scriptures prophesy of a generation that will emerge as an army
            of God to refuse Satan until his things are completely removed from
            their souls, <b>(Joel 2:4-11, Isa 25:6-8).</b> By overcoming Satan,
            the legal stand of Satan and his angels in the heavens of humanity
            would be broken and thus, they will be cast out, giving room for
            salvation to come to all men, <b>(Rev 12:7-10).</b>
            <br />
            <br />
            It is good to know that Satan is afraid of the emergence of this
            generation and is doing everything possible to devour them,{" "}
            <b>(1 Pet 5:8).</b> However, we know the word of the Lord would be
            fulfilled because we are that generation that would give ourselves
            to all allocations of God's word (milk, meat, and strong meat),{" "}
            <b>(1 Cor. 3:1-3, Heb. 5:12-14, 6:1)</b> until we become the
            incorruptible, indestructible, and unfading generation to the praise
            and glory of God our Father and our Lord Jesus Christ. Amen.
          </Content>
        </Section>
        <br />
      </Section>
      <Section>
        <SubSection>
          <Title>Conclusion</Title>
          <Content>
            By God's grace, we have been able to study God's vision for all
            believers to attain incorruptibility, which is a state of immunity
            to corruption. We have seen that the only means by which a believer
            can attain this estate is by feeding on the three meals the Lord has
            provided by preachers and teachers of his word: the milk, the meat,
            and the strong meat of the word.
            <br />
            <br />
            The milk, which is the dispensation of the Holy Ghost limits the
            process of corruption but cannot arrest the program in the soul. The
            meat, which is dispensation of Christ, on the other hand, is God's
            provision to arrest the program of corruption in the soul but cannot
            immune the soul from corruption.
            <br />
            <br />
            Thus, the need for the strong meat of the word, which is the
            dispensation of the Father or incorruptible seed - the provision
            that can make the soul of a believer immune, indestructible or saved
            by expunging the root of corruption (corruptible seed) from the
            soul.
            <br />
            <br />
            Thus, as believers, who are interested in attaining all of God's
            expectation, we must not be tired of feeding and obeying until we
            have become Sons of God, immune from Satan's schemes. We pray
            everyone would return with this vision and an undying passion to
            obey God till we are saved to the uttermost in Jesus name. Amen.
            <br />
            <br />
            See you at GBS 5.0!
          </Content>
        </SubSection>
      </Section>
      <WithLove />
    </>
  );
}
